import { HttpMethod } from '../Common/useFetch';
import { RequestOptions } from '../Common/useRequest';
import useUserRequest from '../Common/useUserRequest';
import { useSelectedBusiness } from '../UserAccess/useSelectedBusiness';
import { BusinessUserCreateDto, BusinessUserUpdateDto } from './useGetUsers';

const usersPath = (businessId: string) => `/api/businesses/${businessId}/users`;

export const useCreateBusinessUser = (options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<BusinessUserCreateDto>(
    { path: usersPath(business.id), method: HttpMethod.POST },
    options);
};

export const useUpdateBusinessUser = (userId: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<BusinessUserUpdateDto>(
    { path: `${usersPath(business.id)}/${userId}`, method: HttpMethod.PUT },
    options);
};
